import { SCREENS } from 'src/constants/screens';
import { IScreenTab } from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import { appStore } from '~/mobx/appStore';

export const marketingNavigation = (): IScreenTab[] => {
  const screens = [
    { path: SCREENS.PROMOCODES(), title: 'marketing_promo_and_cashback_tab' },
    { path: SCREENS.PROMOBANNERS(), title: 'promo_banners', visible: appStore.isAddonsAvailable.promoBanners },
    { path: SCREENS.MESSAGE_CAMPAIGNS(), title: 'Message campaign' },
    { path: SCREENS.CASHBACK(), title: 'cashback', visible: appStore.isAddonsAvailable.cashback },
    { path: SCREENS.DEALS(), title: 'combo_offer_tab', visible: appStore.isAddonsAvailable.deals },
  ];

  return screens;
};
